import { render, staticRenderFns } from "./casesUserMsg.vue?vue&type=template&id=7e529443&scoped=true"
import script from "./casesUserMsg.vue?vue&type=script&lang=js"
export * from "./casesUserMsg.vue?vue&type=script&lang=js"
import style0 from "./casesUserMsg.vue?vue&type=style&index=0&id=7e529443&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e529443",
  null
  
)

export default component.exports